// src/pages/NotFound.js
// 404 for any URL no route matches. Signed-in users keep the sidebar; everyone
// else gets the signed-out card.
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useStore } from '../store';
import Layout from '../components/layout/Layout';
import AuthCard, { fullWidthBtn } from '../components/AuthCard';

function Message({ signedIn }) {
  const { pathname } = useLocation();
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 56, fontWeight: 800, color: '#0f766e', lineHeight: 1 }}>404</div>
      <h1 style={{ fontSize: 16, fontWeight: 700, color: '#1a1f2e', margin: '12px 0 6px' }}>Page not found</h1>
      <p style={{ fontSize: 12, color: '#8892a4', lineHeight: 1.6, marginBottom: 20, wordBreak: 'break-all' }}>
        There's nothing at <code>{pathname}</code>. The link may be mistyped, or the page may have moved.
      </p>
      <Link to={signedIn ? '/dashboard' : '/login'} className="btn btn-primary" style={signedIn ? undefined : fullWidthBtn}>
        {signedIn ? 'Go to dashboard' : 'Go to sign in'}
      </Link>
    </div>
  );
}

// The signed-in 404 body, for use inside the app layout.
export function NotFoundPanel() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 16px' }}>
      <div className="card" style={{ padding: 32, width: 420, maxWidth: '100%' }}><Message signedIn /></div>
    </div>
  );
}

export default function NotFound() {
  const { user, authChecked } = useStore();
  if (!authChecked) return null; // waiting on GET /auth/me
  if (!user) return <AuthCard subtitle="Page not found"><Message signedIn={false} /></AuthCard>;
  return <Layout><NotFoundPanel /></Layout>;
}
